export default "__VITE_ASSET__DLjiuzRc__"